import $ from 'jquery'
export default {
    install(Vue, options) {
        // 封装的页面公用方法
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/allJs.js